<template>
  <div class="directAdditionPage">
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" :close-on-press-escape="false" width="800px">
      <!-- 订单商品直接添加 -->
      <div>{{ $t("message.orderGoodsDirectlyAdded") }}：</div>
      <el-table :data="tableData" border :key="isUpdate" style="width: 100%;margin:20px 0">
        <el-table-column prop="No" label="No" align="center" width="50">
        </el-table-column>
        <!--      链接-->
        <el-table-column :label="$t('message.link')" align="center" width="300">
          <template v-slot="scope">
            <!--      请输入rakumrat平台的商品链接-->
            <el-input v-model="scope.row.link" @blur="getGoodsMessage(scope.row.link, scope.$index)"
              onfocus="this.select()" :placeholder="$t('message.pleaseEnterTheMerchandiseLinkForRakumratPlatform')" />
          </template>
        </el-table-column>
        <!--      商品属性-->
        <el-table-column align="center" width="209" :label="$t('message.commodityAttribute')">
          <template v-slot="scope">
            <div class="attributeEdit flexAndCenter">
              <div class="attribute">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in scope.row.detail" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in scope.row.detail" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
              <div class="edit" v-if="scope.row.detail.length > 0">
                <i class="el-icon-edit-outline" @click="attributeEdit(scope.row, scope.row.No)"></i>
              </div>
            </div>
          </template>
        </el-table-column>
        <!--      数量-->
        <el-table-column align="center" width="100" :label="$t('message.quantity')">
          <template v-slot="scope">
            <el-input v-model.number="scope.row.num" type="number" onfocus="this.select()"
              @keydown.native="newChannelInputLimit" />
          </template>
        </el-table-column>
        <!--      增减-->
        <el-table-column align="center" width="100" :label="$t('message.increaseOrDecrease')">
          <template v-slot="scope">
            <div class="redemptionOperationBtnList">
              <div style="margin-right: 10px" @click="addReplaceGoodsLink">
                <i class="el-icon-plus"></i>
              </div>
              <div style="margin-right: 10px" @click="deleteReplaceGoodsLink(scope.row)">
                <i class="el-icon-minus"></i>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <!--提交-->
        <el-button class="secondary" @click="returnToOrderTable">{{ $t("message.submit") }}</el-button>
      </div>

    </el-dialog>
    <!-- 属性编辑 -->
    <attribute v-if="attributeDialogVisible" :detail="itemDetail" />
  </div>
</template>

<script>
import attribute from "@/views/orderDetail/components/attribute";

export default {
  components: {
    attribute
  },
  data() {
    return {
      dialogVisible: false,
      tableData: [{
        No: 1,
        link: '',
        mi_id: '',
        detail: [],
        num: 1
      }],
      isUpdate: true,
      i: null,
      itemDetail: {},
      attributeDialogVisible: false, //属性编辑
    }
  },
  methods: {
    //向订单数组中添加一项
    addReplaceGoodsLink() {
      this.tableData.push({
        No: this.tableData.length + 1,
        link: '',
        mi_id: '',
        detail: [],
        num: 1
      });
    },
    //删除订单商品
    deleteReplaceGoodsLink(row) {
      if (this.tableData.length === 1) {
        this.tableData = [{
          No: 1,
          link: '',
          detail: [],
          num: 1
        }]
        return;
      }
      this.tableData.forEach((item, index) => {
        if (row.No === item.No) {
          this.tableData.splice(index, 1);
        }
      });
      this.tableData.forEach((item, index) => {
        item.No = index + 1;
      });
    },
    //通过链接获取商品详情
    getGoodsMessage(link, i) {
      console.log(link, i);
      this.$api.goodsUrlToGoodsId({ goods_url: link }).then(res => {
        const miId = res.data.mi_id || ''
        let timestamp = Math.floor(new Date().valueOf() / 1000)
        let sign = 'wakanda forever!@9523`'
        let datas = {
          shop_type: res.data.from_platform,
          goods_id: res.data.goods_id,
          mi_id: miId,
          timestamp,
          sign: this.$md5(`${sign}${timestamp}${sign}`)
        };

        this.$api.orderApi.goodsParticulars(datas).then((res) => {
          let detail = [];

          res.data.goodsInfo.specification.forEach((item, specificationIndex) => {
            console.log(item);

            detail.push({
              key: item.keyC,
              value: item.valueC[0].name,
            })
            // if (item.valueC[0].picUrl !== '') {
            //  let pic = item.valueC[0].picUrl;
            // }
          });


          let data = res.data;
          console.log(data);
          this.goodsInventory = res.data.goodsInfo.goodsInventory;
          this.i = i;
          this.tableData[i].goodsId = data.goodsId;
          this.tableData[i].mi_id = data.mi_id || data.miId || miId;
          this.tableData[i].goods_title = data.titleC;
          this.tableData[i].shop_id = data.shopId;
          this.tableData[i].shop_name = data.shopName;
          this.tableData[i].from_platform = data.fromPlatform;
          this.tableData[i].pic = data.images[0];
          this.tableData[i].show = true;
          this.tableData[i].detail_y = [];
          this.tableData[i].link = link;
          this.tableData[i].detail = detail;
          this.tableData[i].detail_y = detail;
          this.tableData[i].num = 1;
          this.tableData[i].goodsInfo = res.data.goodsInfo
          this.tableData[i].specId = this.goodsInventory[0].valueC[0].specId
          this.tableData[i].skuId = this.goodsInventory[0].valueC[0].skuId
          this.tableData[i].price = this.goodsInventory[0].valueC[0].price

          // this.tableData[i].price = res.data.goodsInfo
          let datas = {
            user_id: this.$route.query.userID,
            from_platform: [data.fromPlatform]
          }
          this.$api.orderApi.getServiceRate(datas).then(res => {
            this.tableData[i].service_rate = res.data[0].rate
          })
          console.log(this.tableData);
          // }
        });
      })
    },

    // 接收修改属性
    receiveAttributeEdit(data, pic) {
      console.log(pic);
      this.tableData.forEach((item, index) => {
        if (index === this.i - 1) {
          item.detail = data;
          if (pic) {
            item.pic = pic;
          }

        }
      })
      this.attributeDialogVisible = false;
      this.isUpdate = !this.isUpdate;
    },
    //输入框校验
    newChannelInputLimit(e) {
      let key = e.key;
      // 不允许输入'e'、'.'、'。'、'-'
      if (key === "e" || key === "." || key === "。" || key === "-") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    stopScroll(evt) {
      evt = evt || window.event;
      if (evt.preventDefault) {
        // Firefox
        evt.preventDefault();
        evt.stopPropagation();
      } else {
        // IE
        evt.cancelBubble = true;
        evt.returnValue = false;
      }
      return false;
    },
    //将弹窗内的商品返回到预览页面
    returnToOrderTable() {
      if (this.tableData.length === 1 && (this.tableData[0].detail.length === 0 && this.tableData[0].num === 1)) {
        this.$message.error(this.$t('message.pleaseAddAtLeastOneItem'))//请至少添加一个商品
        return
      }
      console.log(this.tableData);
      this.$emit('getDirectAdditionOrder', { orderList: this.tableData })
      this.tableData = [{
        No: 1,
        link: '',
        mi_id: '',
        detail: [],
        num: 1
      }];
    },
    //商品属性修改
    attributeEdit(item, i) {

      this.i = i;
      this.itemDetail = {
        from_platform: item.fromPlatform ? item.fromPlatform : item.from_platform,
        goods_id: item.goodsId,
        mi_id: item.mi_id || '',
      };
      this.attributeDialogVisible = true;
      this.$forceUpdate()
    },
  }
}
</script>

<style lang="scss" scoped>
.directAdditionPage {
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }

  .redemptionOperationBtnList {
    display: flex;
    align-items: center;

    div {
      width: 35px;
      height: 35px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #000;
      flex-shrink: 0;
      cursor: pointer;
    }

    /deep/ .el-icon-plus,
    /deep/ .el-icon-minus {
      font-size: 22px;
    }
  }

  .attributeEdit {
    justify-content: space-between;

    .attribute {
      text-align: left;
      width: 100%;
      padding: 3%;

      .row {
        width: 100%;
        margin-bottom: 5px;
      }
    }

    .edit {
      width: 20px;
      height: 20px;
      margin-left: 5px;

      i {
        font-size: 20px;
        color: #2c96e7;
        cursor: pointer;
      }
    }
  }
}
</style>
